import FredEmptyState from './EmptyState/FredEmptyState';
import {Utils} from '../../../../utils/Globals';
export const fileConfigFred = {
	// if this is provided then the component will not be used as recents anymore.
	clientInfo: {
		clientVersion: '1.1.0',
		clientId: 'CCHomeRecent',
		surface: 'CCWeb',
	},
	sort: {
		sortBy: 'ModificationDate', // ModificationDate Size Name if not provided ModificationDate is default
		sortOrder: 'Descending', // Ascending and Descending if not provided Descending is defaulted
	},
	showTiles: {
		all: true,
		yourFiles: false,
		yourSpaces: true,
		sharedWithYou: false,
	},
	defaultTileValue: 'All', // will take All YourFiles SharedWithYou. YourSpaces will fetch result from all spaces
	includeLibraryElements: true,
	showSearchBar: false,
	limit: 20, // 1 to 50 if not prpovided default will be taken as 5
	sources: ['CreativeCloud'], // is a must need to provide
	rendition: {
		size: {
			default: {
				image: 240,
			},
		},
	},
	useSessionStorage: true,
	infiniteScroll: {
		useInternal: false,
		scrollingElement: 'body',
		scrollingContent: '.app-container',
	},
	fileType: 'canvas',
	newFileCallback: () => {}, // if not provided the button wont be shown
	newFileCtaString: Utils.localizedStrings['appHomes.files.newCanvas'],
	newFileButtonProps: {
		disabled: false,
	},
	filter: {
		documentTypes: ['Canvas'],
	},
	emptyStateComponent: FredEmptyState,
	label: 'Creative Cloud Canvas',
};
